import React from "react";
import YouTubeShortFooter from "./YouTubeShortFooter";
import { useIsMobile } from "../../../hooks/useIsMobile";
import { Loader } from "lucide-react";

const YouTubeShortPreview = ({ post }: { post: any }) => {
  const isMobile = useIsMobile(900);
  const mainMedia = post.media && post.media.length > 0 ? post.media[0] : null;

  // const getChannelInitials = (name?: string) => {
  //   if (!name) return "YT";
  //   const parts = name
  //     .split(" ")
  //     .filter(Boolean)
  //     .map((n) => n[0])
  //     .join("")
  //     .toUpperCase();
  //   return parts.slice(0, 2) || "YT";
  // };

  return (
    <div className="border border-gray-200 rounded-lg p-3">
      <div className={`flex items-start ${isMobile ? "flex-col" : "gap-2 justify-between"}`}>
        {/* Video */}
        <div className="relative flex-1 rounded-lg overflow-hidden select-none">
          <div className="w-full aspect-[9/16] relative">
            {mainMedia ? (
              mainMedia.isProcessing ? (
                <>
                  {mainMedia.thumbnail && (
                    <img
                      src={mainMedia.thumbnail}
                      alt="Media"
                      className="w-full h-full object-contain"
                    />
                  )}
                  <div className="absolute inset-0 bg-black/60 flex items-center justify-center rounded">
                    <span className="text-white text-sm font-medium">Video Processing</span>
                    <Loader className="ml-2 animate-spin text-secondary" />
                  </div>
                </>
              ) : (
                <>
                  <video
                    src={mainMedia.signedUrl || mainMedia.url}
                    className="w-full h-full object-contain"
                    loop
                    playsInline
                    controls
                  />

                  {/* Bottom overlay — channel name, title */}
                  {/* <div className="absolute bottom-0 left-0 w-full px-3 pb-3 pt-10 bg-gradient-to-t from-black/80 via-black/40 to-transparent pointer-events-none">
                    <div className="flex items-center gap-2 mb-1">
                      {post?.userImage ? (
                        <img
                          src={post.userImage}
                          alt="User"
                          className="w-8 h-8 rounded-full object-cover"
                        />
                      ) : (
                        <span className="w-8 h-8 flex items-center justify-center bg-gray-300 text-xs font-semibold rounded-full">
                          {getChannelInitials(post?.displayName)}
                        </span>
                      )}
                      <span className="text-sm font-semibold text-white truncate">
                        {post?.displayName || "Channel Name"}
                      </span>
                    </div>
                    <p className="text-left w-full text-sm text-white font-extrabold truncate">
                      {post?.title}
                    </p>
                  </div> */}
                </>
              )
            ) : (
              <div className="w-full h-full flex items-center justify-center text-white">
                No Video
              </div>
            )}
          </div>
        </div>

        {/* Footer */}
        {isMobile ? (
          <div className="mt-4 w-full">
            <YouTubeShortFooter post={post} />
          </div>
        ) : (
          <div className="flex-1 border border-gray-300 rounded-xl">
            <YouTubeShortFooter post={post} />
          </div>
        )}
      </div>
    </div>
  );
};

export default YouTubeShortPreview;
